import { OVERRIDE_LINKS } from './constants';

const getSofaBuilderLink = (collectionName, link, showMarxent) => {
  if (showMarxent || !collectionName) {
    return link;
  }
  return OVERRIDE_LINKS[collectionName] || link;
};

export default getSofaBuilderLink;
